import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Stocks from '@/features/stocks'

export const Route = createFileRoute('/_authenticated/stocks/')({
  component: Stocks,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Stocks`,
      },
    ],
  }),
  // beforeLoad: async () => {
  //   try {
  //     const res = await getCurrentUser()
  //     if (!res?.id) {
  //       throw redirect({
  //         to: '/sign-in-2',
  //       })
  //     }
  //   } catch (_) {
  //     throw redirect({
  //       to: '/sign-in-2',
  //     })
  //   }
  // },
})
